import { Divider, Flex, Space, Spacing } from '@billy/design-system'
import { ReactElement } from 'react'

import { Scope } from '../../../../../../../../../../../../enums/scope'
import { isAuthorized } from '../../../../../../../../../../../../utils/isAuthorized'
import { InvoiceEditorVariant } from '../../../../../../../../enums/invoiceEditorVariant'
import { useInvoiceEditorVariant } from '../../../../../../../../hooks/useInvoiceEditorVariant'
import { InvoiceLocalSettings } from './elements/InvoiceLocalSettings'
import { RecurringInvoiceToggle } from './elements/RecurringInvoiceToggle'
import * as Styled from './styles'

const editorVariantsSupportingRecurringToggle = [
  InvoiceEditorVariant.InvoiceNew,
  InvoiceEditorVariant.InvoiceDraftDuplicate,
  InvoiceEditorVariant.InvoiceDuplicate,
  InvoiceEditorVariant.RecurringInvoiceNew,
]

interface InvoiceConfigurationProps {
  onLanguageChange: () => void
}

export const InvoiceConfiguration = ({ onLanguageChange }: InvoiceConfigurationProps): ReactElement => {
  const { invoiceEditorVariant } = useInvoiceEditorVariant()
  const shouldDisplayRecurringInvoiceToggle =
    isAuthorized(Scope.RecurringInvoiceRead) && editorVariantsSupportingRecurringToggle.includes(invoiceEditorVariant)

  return (
    <Flex alignItems="center" gap={Spacing.S6} justifyContent="flex-end" width="100%">
      {shouldDisplayRecurringInvoiceToggle && (
        <Styled.RecurringInvoiceToggleWrapper>
          <RecurringInvoiceToggle />
          <Space horizontal size="s16" />
          <Divider direction="vertical" />
          <Space horizontal size="s4" />
        </Styled.RecurringInvoiceToggleWrapper>
      )}
      <InvoiceLocalSettings onLanguageChange={onLanguageChange} />
    </Flex>
  )
}
